import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import LOOKUP from 'constants/lookup';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardSimple from 'screens/components/basic/CardSimple';

const componentName = "WarehouseTransfer";

class Header extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let props = this.props;
        return (
            <CardSimple className="p-1">
                <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.beginDate.name}
                            floatingLabelText={LOOKUP.report.common.beginDate.label}
                            hintText={LOOKUP.report.common.beginDate.label}
                            fullWidth={true}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <DatePickerInput
                            name={componentName + LOOKUP.report.common.endDate.name}
                            floatingLabelText={LOOKUP.report.common.endDate.label}
                            hintText={LOOKUP.report.common.endDate.label}
                            fullWidth={true}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <SelectInput
                            name={`${componentName}FromBranch`}
                            className="search-field"
                            label="Branch From"
                            floatingLabelText="Branch From"
                            defaultValue="0"
                            options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                        />
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <SelectInput
                            name={`${componentName}ToBranch`}
                            className="search-field"
                            label="Branch To"
                            floatingLabelText="Branch To"
                            defaultValue="0"
                            options={props.branchOptions && props.branchOptions.length > 0 ? props.branchOptions : []}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <SelectInput
                            defaultValue="1"
                            name={componentName + "Action"}
                            fullWidth={true}
                            label={"Status"}
                            floatingLabelText={"Status"}
                            hintText={"Status"}
                            options={props.reportactions && props.reportactions.length > 0 ? props.reportactions : []}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <SelectInput
                            defaultValue="0"
                            name={componentName + "IsCannabis"}
                            fullWidth={true}
                            label={"Is Cannabis"}
                            floatingLabelText={"Is Cannabis"}
                            hintText={"Is Cannabis"}
                            options={props.isCannabisOptions}
                        />
                    </div> {/* .col */}
                    <div className="col-xs-6 col-sm-6 col-md-3">
                        <SelectInput
                            defaultValue="2"
                            name={componentName + "Transfer"}
                            fullWidth={true}
                            label={"Transfer Type"}
                            floatingLabelText={"Transfer Type"}
                            hintText={"Transfer Type"}
                            options={props.transferOptions && props.transferOptions.length > 0 ? props.transferOptions : []}
                        />
                    </div> {/* .col */}
                    {
                        props.transferType == 1 && <div className="col-xs-6 col-sm-6 col-md-3">
                            <SelectInput
                                defaultValue="1"
                                name={componentName + "Warehouse"}
                                fullWidth={true}
                                label={"Warehouse"}
                                floatingLabelText={"Warehouse"}
                                hintText={"Warehouse"}
                                options={props.warehouseOptions && props.warehouseOptions.length > 0 ? props.warehouseOptions : []}
                            />
                        </div>
                    }

                    <div className="col-xs-12 col-sm-12 col-md-5 col-lg-12">
                        <Button
                            type="IconInButton"
                            className="pull-right mt-2 ml-1 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.viewReport.name}
                            label={LOOKUP.report.common.viewReport.label}
                            icon={<VisibilityIcon />}
                            onTouchTap={props.showBody}
                        />
                        <Button
                            type="DownloadButton"
                            className="pull-right mt-2 btnNewBrandPOS"
                            name={componentName + LOOKUP.report.common.downloadReport.name}
                            label={LOOKUP.report.common.downloadReport.label}
                            onTouchTap={props.download}
                        />
                    </div>
                </div>
            </CardSimple>
        );
    }
}

const mapStateToProps = state => {
    return {
        transferType: state.form.WarehouseTransferTransfer
    };
};

export default connect(mapStateToProps)(Header);